import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import AddToCalendar from "react-add-to-calendar";
import moment from "moment";
import "./ScheduleRetro.css";
import { settingsConstants } from "../shared/_constants.js";

class ScheduleRetro extends Component {
  constructor() {
    super();

    this.state = {
      showRecurringReminder: false,
    };
  }

  handleUpdateTeamName = event => {
    const teamNameValue = event.target.value;
    this.props.commitUpdatedSettings("teamName", teamNameValue);
  };

  handleUpdateFrequency = selectedFrequency => {
    const frequencyValue = selectedFrequency.value;
    this.props.commitUpdatedSettings("frequency", frequencyValue);
  };

  handleUpdateDay = selectedDay => {
    const dayValue = selectedDay.value;
    this.props.commitUpdatedSettings("day", dayValue);
  };

  handleUpdateTime = selectedTime => {
    const timeValue = selectedTime.value;

    this.props.commitUpdatedSettings("time", timeValue);
  };

  getDesiredMoment = () => {
    //Goal is to pass in a proper Datetime to the Add to Calendar button
    const currentMoment = moment();
    var desiredMoment;

    //Sets the current day of week and time
    const currentDayTime = currentMoment.format("e HH:mm");
    //Sets the desired day of week and time based on Settings state
    const selectedDayTime =
      this.props.settings.day + " " + this.props.settings.time;

    //Comparison to see if the desired day and time is after the current
    // day and time. If so, it adds 7 days to go to the next week
    if (currentDayTime <= selectedDayTime) {
      desiredMoment = moment(currentMoment);
      desiredMoment.weekday(this.props.settings.day);
    } else {
      desiredMoment = moment(currentMoment);
      desiredMoment.weekday(this.props.settings.day + 7);
    }

    const parsedHour = moment(this.props.settings.time, "HH:mm").hour();
    const parsedMinute = moment(this.props.settings.time, "HH:mm").minute();

    desiredMoment
      .hour(parsedHour)
      .minute(parsedMinute)
      .second(0);

    return desiredMoment;
  };

  getEventTitle = () => {
    var title = "";
    const teamName = this.props.settings.teamName;
    const frequency = this.props.settings.frequency;

    if (teamName) {
      title += teamName;
    } else {
      title += "Team";
    }

    title += " ";

    if (frequency !== "other") {
      title += frequency;
      title += " ";
    }

    title += "Outro";

    return title;
  };

  toggleRecurringReminder = bool => {
    //Using setTimeout because without it, the apple and outlook calendars don't download properly.
    setTimeout(() => {
      this.setState({
        showRecurringReminder: bool,
      });
    }, 300);
  };

  handleAddToCalendarClick = () => {
    window.analytics.track("Opens Add to Calendar Dropdown");

    //after the Add to Calendar button expands, attach click handlers to each
    //of the calendar options to track segment events. Must add a setTimeout
    //so we can identify the newly loaded DOM elements
    setTimeout(() => {
      //Have to define locally, idk why
      let toggleRecurringReminder = this.toggleRecurringReminder;

      let google = document.getElementsByClassName("google-link");
      let trackGoogleClick = function() {
        toggleRecurringReminder(true);
        window.analytics.track("Opens Calendar Event", {
          calendar: "google",
        });
      };
      Array.from(google).forEach(function(element) {
        element.addEventListener("click", trackGoogleClick);
      });

      let apple = document.getElementsByClassName("apple-link");
      let trackAppleClick = function() {
        toggleRecurringReminder(true);
        window.analytics.track("Opens Calendar Event", {
          calendar: "apple",
        });
      };
      Array.from(apple).forEach(function(element) {
        element.addEventListener("click", trackAppleClick);
      });

      let outlookcom = document.getElementsByClassName("outlookcom-link");
      let trackOutlookcomClick = function() {
        toggleRecurringReminder(true);
        window.analytics.track("Opens Calendar Event", {
          calendar: "outlookcom",
        });
      };
      Array.from(outlookcom).forEach(function(element) {
        element.addEventListener("click", trackOutlookcomClick);
      });

      let outlook = document.getElementsByClassName("outlook-link");
      let trackOutlookClick = function() {
        toggleRecurringReminder(true);
        window.analytics.track("Opens Calendar Event", {
          calendar: "outlook",
        });
      };
      Array.from(outlook).forEach(function(element) {
        element.addEventListener("click", trackOutlookClick);
      });
    }, 300);
  };

  render() {
    const desiredMoment = this.getDesiredMoment();

    const event = {
      title: this.getEventTitle(),
      description:
        "Outro is a new take on team retrospectives** for progressive teams like yours.\nNo need for each team member to sign up for a separate account, only the meeting host needs one. Just show up ready to participate!\n\n**A retrospective is a team meeting that celebrates everyone’s hard work and builds a culture of constant improvement. When done right, it creates more effective, more close-knit teams.\n\nTo learn the ins and outs of a great retro, read: https://medium.com/@taykcrane/hitting-reset-on-retros-79a4f82f34e6\n\nVisit https://outro.co for more info.",
      startTime: desiredMoment,
      endTime: moment(desiredMoment).add(1, "hours"),
      location: "",
    };

    const calendars = [
      { google: "Google Calendar" },
      { apple: "Apple Calendar" },
      { outlookcom: "Outlook.com (Web)" },
      { outlook: "Outlook (Desktop)" },
    ];

    return (
      <div className="schedule-container">
        <div className="team-name">
          <p>What's your team's name?</p>
          <form
            onSubmit={event => {
              event.preventDefault();
              this.teamNameInput.blur();
            }}
            className="team-name-form input-container editable-container"
          >
            <input
              type="text"
              onChange={event => this.handleUpdateTeamName(event)}
              value={this.props.settings.teamName}
              ref={input => (this.teamNameInput = input)}
              className="editable-input"
              placeholder="Team or Company Name"
            />
          </form>
        </div>
        <div className="frequency">
          <p>How often will you host a retro?</p>
          <div className="frequency-dropdown">
            <Select
              name="frequency-dropdown"
              value={this.props.settings.frequency}
              onChange={this.handleUpdateFrequency}
              options={settingsConstants.frequencyOptions}
              clearable={false}
              searchable={false}
              style={{
                boxShadow: "none", // removes the random blue outline that can't be done with CSS for some reason
              }}
            />
          </div>
        </div>
        <div className="day-and-time">
          <p>When is best for your team?</p>
          <div className="day-time-dropdown-container">
            <div className="day-dropdown">
              <Select
                name="day-dropdown"
                value={this.props.settings.day}
                onChange={this.handleUpdateDay}
                options={settingsConstants.dayOptions}
                clearable={false}
                searchable={false}
                style={{
                  boxShadow: "none", // removes the random blue outline that can't be done with CSS for some reason
                }}
              />
            </div>
            <div className="at">at</div>
            <div className="time-dropdown">
              <Select
                name="time-dropdown"
                value={this.getDesiredMoment().format("HH:mm")}
                onChange={this.handleUpdateTime}
                options={settingsConstants.timeOptions}
                clearable={false}
                searchable={false}
                style={{
                  boxShadow: "none", // removes the random blue outline that can't be done with CSS for some reason
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="add-to-calendar"
          onClick={this.handleAddToCalendarClick}
        >
          <AddToCalendar
            event={event}
            buttonLabel="Add to Calendar"
            buttonTemplate={{ textOnly: "none" }}
            displayItemIcons={false}
            listItems={calendars}
          />
        </div>
        {this.state.showRecurringReminder ? (
          <div className="recurring-reminder">
            <span>Protip: </span>The scheduler can't make the invite recurring.
            You'll have to enable that yourself!
          </div>
        ) : null}
      </div>
    );
  }
}

ScheduleRetro.propTypes = {
  settings: PropTypes.shape({
    teamName: PropTypes.string,
    frequency: PropTypes.oneOf(["weekly", "bi-weekly", "monthly", "other"])
      .isRequired,
    day: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]).isRequired,
    time: PropTypes.isRequired,
    freeRetros: PropTypes.number.isRequired,
  }),
  commitUpdatedSettings: PropTypes.func.isRequired,
};

export default ScheduleRetro;



// WEBPACK FOOTER //
// ./src/components/ScheduleRetro.js